var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-0 ",attrs:{"fluid":""}},[_c('transaction-detail'),_c('sidebar-layout',{attrs:{"links":_vm.sidebarMenu}},[_c('transitionPage',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }